import React from 'react';

import {
  fundsCategoriesQuery,
  fundsProductsQuery,
} from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getFundsFilters, tableHead } from './constants';
import ProductItem from './item';

export const FundsTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={fundsProductsQuery}
      productCategoryQuery={fundsCategoriesQuery}
      productsFiltersGetter={getFundsFilters}
      tableHeadItems={tableHead}
      tabletColumns={4}
      mobileFields={[
        { key: 'customerNormalized', label: 'Cliente' },
        { key: 'assetNormalized', label: 'Ativo' },
        { key: 'quoteDateNormalized', label: 'Data da cota' },
        { key: 'quoteAnualValueNormalized', label: 'Valor da cota anual' },
        { key: 'quoteQuantityNormalized', label: 'Quantidade de cotas' },
        { key: 'grossValueNormalized', label: 'Valor bruto' },
        { key: 'netValueNormalized', label: 'Valor líquido' },
      ]}
    />
  );
};
